import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { SPACES } from 'common/constants/sizes';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';

const NoActivityIcon = styled.img`
  ${({ imageSize }) => `width: ${imageSize ? imageSize : '1.8rem'}`};
`;

const ProjectColumnEmptyState = ({
  image,
  imageSize,
  icon,
  message,
  messageComponent,
  alignItems = 'center'
}) => {
  return (
    <Flex items={alignItems} height='100%'>
      {image ? (
        <NoActivityIcon
          imageSize={imageSize}
          src={image}
          alt=''
          data-testid='empty-state-image'
        />
      ) : icon ? (
        <Icon
          name={icon}
          size='normal'
          color='shuttleGray'
          data-testid='empty-state-icon'
          isThin
        />
      ) : (
        <></>
      )}
      {messageComponent ? (
        messageComponent
      ) : (
        <Text
          size='small'
          color='shuttleGray'
          pl={SPACES['small']}
          data-testid='empty-state-message'
        >
          {message}
        </Text>
      )}
    </Flex>
  );
};

export default ProjectColumnEmptyState;
